import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../store/store";
import DocumentTypeService from '../services/DocumentTypeService';
import { loadingDocumentTypeDropdown } from '../store/slices/documentTypes/documentTypeSlice';

export const useDocumentType = () => {
  const dispatch: AppDispatch = useDispatch();

  const { documentTypeDropdown } = useSelector(
    (state: RootState) => state.documentType
  );

  const fetchDocumentTypeDropdown = async () => {
    try {
      const response = await DocumentTypeService.fetchDropdown();
      dispatch(loadingDocumentTypeDropdown(response));
    } catch (error) {
      console.error("Error al cargar document types:", error);
    }
  };

  return {
    documentTypeDropdown,
    fetchDocumentTypeDropdown,
  };
};
